import React from 'react';
import { Modal } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPrint, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../../../components/Button/Button';
import classes from './no-bill-warning-modal.module.scss';

export type NoBillWarningModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  message?: React.ReactNode;
  hint?: React.ReactNode;
  confirmLabel?: string;
  confirmTestId?: string;
  zIndex?: number;
};

// Summary: Payment-screen warning that this dine-in order reached payment without a printed bill.
const NoBillWarningModalComponent: React.FC<NoBillWarningModalProps> = ({ opened, onClose, onConfirm, message, hint, confirmLabel = 'הבנתי, המשך', confirmTestId = 'no-bill-warning-confirm', zIndex }) => (
  <Modal
    opened={opened}
    zIndex={zIndex}
    onClose={onClose}
    size="sm"
    centered
    radius="lg"
    dir="rtl"
    withCloseButton={false}
    closeOnClickOutside={false}
    closeOnEscape={false}
    classNames={{ content: classes.content, body: classes.modalBody }}
  >
    <div className={classes.header}>
      <FontAwesomeIcon icon={faTriangleExclamation as IconProp} className={classes.icon} />
      <h2 className={classes.title}>שים לב!</h2>
    </div>
    <div className={classes.body}>
      <p className={classes.message}>
        {message ?? <>להזמנה זו <strong>לא הודפס חשבון</strong> לפני המעבר לתשלום</>}
      </p>
      <div className={classes.hint}>
        <FontAwesomeIcon icon={faPrint as IconProp} className={classes.hintIcon} />
        <span>{hint ?? 'מומלץ להדפיס חשבון ולהציגו ללקוח לפני הסגירה'}</span>
      </div>
      <div className={onConfirm ? classes.actions : undefined}>
        {onConfirm && <Button variant="cancel" onClick={onClose} fullWidth dataTestId={`${confirmTestId}-cancel`}>ביטול</Button>}
        <Button variant="confirm" onClick={onConfirm ?? onClose} fullWidth dataTestId={confirmTestId}>
          <FontAwesomeIcon icon={faCheck as IconProp} /> {confirmLabel}
        </Button>
      </div>
    </div>
  </Modal>
);

export const NoBillWarningModal = React.memo(NoBillWarningModalComponent);
